import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-h4"},[_vm._v("Group Check Requirements")]),_c(VDivider,{staticClass:"my-2"}),_c('group-check-modal',{attrs:{"loading":_vm.loading,"groups":_vm.scopedGroups,"u":""}}),_c('admin-group-check-data-table',{attrs:{"items":_vm.scopedGroupChecks,"loading":_vm.loading,"logged-in-user-groups":_vm.groupMembership}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }